import type { Subscription } from '@models/Billing'
import { Plan } from '@src/types/common'

// Single source of truth for the top upgrade banner: trial countdown while
// trialing, upgrade nudge on Free, nothing for paying plans. Shared by
// Navigation (renders the banner) and Layout (reserves space for it) so the
// two can never drift apart.
export const showsUpgradeBanner = (subscription?: Subscription): boolean =>
  !!subscription?.is_trial || subscription?.plan === Plan.free
